import { render, staticRenderFns } from "./SquadSize.vue?vue&type=template&id=112b7e50&"
import script from "./SquadSize.vue?vue&type=script&lang=js&"
export * from "./SquadSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports